var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "header",
      class: { fixed: _vm.isFixedHeader },
      attrs: { id: "Header" },
    },
    [
      _c("img", {
        staticClass: "logo",
        attrs: { src: _vm.getLogoImgUrl(), alt: "" },
      }),
      _c(
        "div",
        { staticClass: "flex-content" },
        [
          _c("loginBlock"),
          _c("ul", { staticClass: "menulist" }, [
            _c("li", [_c("record")], 1),
            _c(
              "li",
              [
                _c("settingSelectedBlock", {
                  ref: "settingSelectedBlock",
                  attrs: { "is-open-setting": _vm.isOpenSetting },
                  on: {
                    getOpenSettingStatus: _vm.getOpenSettingStatus,
                    "update:isOpenSetting": function ($event) {
                      _vm.isOpenSetting = $event
                    },
                    "update:is-open-setting": function ($event) {
                      _vm.isOpenSetting = $event
                    },
                  },
                }),
                _vm.isOpenSetting
                  ? _c("div", { staticClass: "setting-group" }, [
                      _c("div", { staticClass: "arrow" }),
                      _c(
                        "div",
                        { staticClass: "menulist-block" },
                        [_c("settingSelectList")],
                        1
                      ),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            !["zh_hk"].includes(_vm.language)
              ? _c(
                  "li",
                  [
                    _c("langSelectedBlock", {
                      ref: "langSelectedBlock",
                      attrs: { "is-open-lang": _vm.isOpenLang },
                      on: {
                        getOpenLangStatus: _vm.getOpenLangStatus,
                        "update:isOpenLang": function ($event) {
                          _vm.isOpenLang = $event
                        },
                        "update:is-open-lang": function ($event) {
                          _vm.isOpenLang = $event
                        },
                      },
                    }),
                    _vm.isOpenLang
                      ? _c("div", { staticClass: "lang-group" }, [
                          _c("div", { staticClass: "arrow" }),
                          _c(
                            "div",
                            { staticClass: "menulist-block" },
                            [
                              _c("langSelectList", {
                                on: { getLangSelected: _vm.getLangSelected },
                              }),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }